// extracted by mini-css-extract-plugin
export default {"footerHotline":"K_cS","helpContainer":"K_cT","helpText":"K_cV","phoneNum":"K_cW","templateTwo":"K_cX","hasAsSeenOn":"K_cY"};